import { render, staticRenderFns } from "./BranceArea.vue?vue&type=template&id=f8f896e2"
import script from "./BranceArea.vue?vue&type=script&lang=js"
export * from "./BranceArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports